module.exports = require("electron-log");